import React, { useEffect, useRef, useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import FormData from 'form-data'
import Select from 'react-select'
import Deletemodal from '../common/Modals/Deletemodal'
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import { Editor } from 'primereact/editor'
import { addProduct, getCategory, getProduct, Baseurl,
  getType, getProductByID, editProductapi,
  getBrandForProdEdit
} from '../../service/apiService'
import ImageCropper from '../common/imagecroper/Imagecroper'
import QuillTextDisplay from '../common/Quiltext/QuillTextDisplay'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { useSnackbar } from 'notistack'
import { Controller } from 'react-hook-form'
const Products = () => {
  const {enqueueSnackbar} = useSnackbar()
  const [show, setShow] = useState(false)
  const [edit,setEdit]= useState(false) 
  const [editproductId,setEditproductId]= useState() 
  const navigate = useNavigate()
  const handleClose = () => { 
    setEdit(false)
    setHeadingPairs([{ heading: '', value: '' }])
    setShow(false)
  }
  const handleShow = () => {
    if(edit === true) return
    if(!edit){
      reset()
      try{
        setAssembleCharge(undefined)
        setAverageRating(undefined)
        setCategory(undefined)
        setFormbrand(undefined)
        setDescription(undefined)
        setIsChecked(true) 
        setMrpprice(undefined)
        setOurprice(undefined)
        setQuantity(undefined)
        setTransptype(undefined)
        setName(undefined)
        setFormImage(undefined)
        setFormsubimage1(undefined)
        setFormsubimage2(undefined)
        setFormsubimage3(undefined)
        setShow(true)
      }catch(e){console.log(e)}
      setShow(true)
      return ''
    }   
  }
  const [categ, setCateg] = useState([])
  const [typedata, setTypedata] = useState([])
  const [brand, setBrand] = useState()
  const [types,setTypes] = useState()
  const [product,setProduct] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const handleDeleteModal = () => setIsModalOpen(false)
  const handleDeleteModalShow = () => setIsModalOpen(true)
  const [deleteid,setDeleteid] = useState([])
  const [name, setName] = useState()
  const [description, setDescription] = useState()
  const [formbrand, setFormbrand] = useState()
  const [category, setCategory] = useState()
  const [type, setType] = useState()
  const [mrpprice, setMrpprice] = useState()
  const [ourprice, setOurprice] = useState()
  const [formtype, setFormtype] = useState()
  const [quantity, setQuantity] = useState()
  const [transptype, setTransptype] = useState()
  const [formimage, setFormImage] = useState()
  const [formsubimage1, setFormsubimage1] = useState()
  const [formsubimage2, setFormsubimage2] = useState()
  const [formsubimage3, setFormsubimage3] = useState()
  const [formsubimages, setFormsubimages] = useState([])
  const [searchterm, setSearchterm] = useState('')
  const [assemblecharge,setAssembleCharge] = useState() 
  const [averageRating,setAverageRating] = useState() 
  const [isChecked, setIsChecked] = useState(true)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const handleToggle = () => {
    setIsChecked(!isChecked)
  }
  const handleYes = () => {
    setIsChecked(true)
  }
  const handleNo = () => {
    setIsChecked(false)
  }

    const image = useRef()
    const subimage1 = useRef()
    const subimage2 = useRef()
    const subimage3 = useRef()
    const subImages = useRef([])

    const [inputValue, setInputValue] = useState('');
    const [items, setItems] = useState([]);
  
    const handleInputChange = (event) => {
      setInputValue(event.target.value);
    };
  
    const handleAddClick = () => {
      if (inputValue.trim() !== '') {
        setItems([...items, inputValue]);
        setInputValue(''); // Clear the input after adding
      }
    };

    const handleKeyPress = (event) => {
      if (event.key === 'Enter') {
        handleAddClick();
      }
    };

    const {
      register,
      formState: { errors },
      trigger,
      getValues,
      setValue,
      reset,
      control, handleSubmit,
    } = useForm();

    const handleSubmits = async (data) => {
      
if(!edit){
  const isAllValid = await trigger();
  if(!image.current.files[0]){
    return alert('Main Image is Required')
  }
  if(isAllValid){
    setShow(false)
    setFormImage(null);
    setFormsubimages([])
    setFormsubimage1([])
    setFormsubimage2([])
    setFormsubimage3([])
    let params = new FormData();
      params.append('name',data.name)
      params.append('description',description)
      params.append('category', data?.category?.value)
      params.append('mrpprice',data?.mrpprice)
      params.append('ourprice',data?.ourprice)
      params.append('image',image.current.files[0]) 
      params.append('subimg1',subimage1.current.files[0]) 
      params.append('subimg2',subimage2.current.files[0]) 
      params.append('subimg3',subimage3.current.files[0]) 
     let jsonString = JSON.stringify(headingPairs);
     params.append( 'specs',jsonString || []) 
      params.append( 'type',data?.type?.value ) 
      params.append('brand',data?.brand?.value)
      params.append('quantity',data?.quantity) 
      params.append('isActive',isChecked) 
      params.append('assembleCharge',assemblecharge || 0)
      params.append('transportationtype',data?.transptype)
    
    let adddata = await addProduct(params)
    setSavedData([])
    await reset()
    if(adddata.status === 200){
      enqueueSnackbar('Product Added',{variant:'success'})
     let product = await getProduct().catch(err => console.log(err))
     setProduct(product.data.data)
     handleClose()
     handlePageChange(totalPages > 1 ? 1 : 0)
     return
    }
    enqueueSnackbar('product adding failed',{variant:'error'})
    handleClose()
  }
}
if(edit){
  const isAllValid = await trigger();
 if(isAllValid){
  let params = new FormData();
  params.append('name',data.name)
  params.append('description',description)
  params.append('category', data?.category?.value)
  params.append('mrpprice',data.mrpprice)
  params.append('ourprice',data.ourprice)
  params.append('image',image.current.files[0]) 
  params.append('subimg1',subimage1.current.files[0]) 
  params.append('subimg2',subimage2.current.files[0]) 
  params.append('subimg3',subimage3.current.files[0]) 
 let jsonString = JSON.stringify(headingPairs);
params.append( 'specs',jsonString || []) 
  params.append( 'type',data.type?.value) 
  params.append('brand',data?.brand.value )
  params.append('quantity',data.quantity)
  params.append('isActive',isChecked)
  params.append('assembleCharge',assemblecharge || 0) 
  // if (assemblecharge !== null || assemblecharge !== undefined || assemblecharge !== '' ){
  //   params.append('assembleCharge',assemblecharge) 
  // }
  params.append('transportationtype',data.transptype)
let editdata = await editProductapi(params,editproductId)
setSavedData([])
await reset()
if(editdata?.status === 200){
  enqueueSnackbar('Product Edited',{variant:'success'})
  let product = await getProduct().catch(err => console.log(err))
  setProduct(product.data.data)
  handleClose()
  handlePageChange(1)
  return
 }
 alert('product Editing failed')
 enqueueSnackbar('Product Edit Failed',{variant:'error'})
 handleClose()
 return
 } 
 }
     
    }

    const [headingPairs, setHeadingPairs] = useState([
      { heading: '', value: '' }
    ]);
    const [savedData, setSavedData] = useState([]);
    const addHeadingPair = () => {
      setHeadingPairs([...headingPairs, { heading: '', value: '' }]);
    };
    
    const updatePair = (index, field, newValue) => {
      const updatedPairs = [...headingPairs];
      updatedPairs[index][field] = newValue;
      setHeadingPairs(updatedPairs);
    };

    const deletePair = (index) => {
      const updatedPairs = headingPairs.filter((_, i) => i !== index);
      setHeadingPairs(updatedPairs);
      savedData.splice(index,1)
    };

    const saveData = () => {
      setSavedData([...headingPairs]);
      console.log('data saved:');
    };
    

    const init = async () => {
     let branddata = await getBrandForProdEdit()
     let brandoptions = branddata?.data?.data.map((item) => ({value:item._id,label:item.name}))
     setBrand(brandoptions)
     let catrgorydata =  await getCategory()
     let categoryOptions = catrgorydata?.data?.data?.map((item) => ({value:item._id,label:item.name}))
     setCateg(categoryOptions)
     let type = await getType()
     let typeoptions = type?.data?.data.map((item) => ({value:item._id,label:item.name}))
     setTypedata(typeoptions)
    }


  const handleImageChange = (event) => {
    event.preventDefault()
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (e) => {
        setFormImage(e.target.result);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }; 

  const handleImageChange1 = (event) => {
    event.preventDefault()
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (e) => {
        setFormsubimage1(e.target.result);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }; 

  const handleImageChange2 = (event) => {
    event.preventDefault()
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (e) => {
        setFormsubimage2(e.target.result);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }; 

  const handleImageChange3 = (event) => {
    event.preventDefault()
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (e) => {
        setFormsubimage3(e.target.result);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }; 

  const handleSubimages = (event) => {
    event.preventDefault()
    const files = Array.from(event.target.files);
    const newImages = [];
    files.map((file) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        newImages.push(e.target.result);
        if (newImages.length === files.length) {
          setFormsubimages([...formsubimages, ...newImages]); // Append new images
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const handleRemoveImage = (index) => {
    try{
      if(index === 1){
        image.current.value = null
        image.current.file = null
        setFormImage(null);
      }

      if(index === 2){
        subimage1.current.value = null
        subimage1.current.file = null
        subimage1.current.files[0] = 'remove'
        setFormsubimage1(null);
      }

      if(index === 3){
        subimage2.current.value = null
        subimage2.current.file = null
        subimage2.current.files[0] = 'remove'
        setFormsubimage2(null);
      }

      if(index === 4){
        subimage3.current.value = null
        subimage3.current.file = null
        subimage3.current.files[0] = 'remove'
        setFormsubimage3(null);
      }
    
    }catch(err){
      console.log(err); 
    }
  };


  const handleRemoveImages = (indexToRemove) => {

    if(indexToRemove === 0 && subImages.current.files.length)subImages.current.value = null
   
    console.log(subImages,'image',subImages.current.files.length);
    console.log(formsubimages,'formsubimages',typeof(subImages.current.files));
    
    // subImages?.current?.files?.splice(indexToRemove,1)
    // image.current.file[indexToRemove] = {}
    setFormsubimages((prevImages) =>
      prevImages.filter((_, index) => index !== indexToRemove)
    );
    // // subImages?.current?.files?.splice(indexToRemove,1)
  };

  const handleBrandChange = (selectedOption) => {
    setFormbrand(selectedOption);
  }; 

  const handleCategoryChange = (selectedOption) => {
    try{
      setCategory(selectedOption);
    }catch(e){
      console.log(e,'from select')
    }
  };

   const handleTypeChange = (selectedOption) => {
    setType(selectedOption);
  };

  const handleProductDelete = async (id) => {
    setDeleteid(id)
    handleDeleteModalShow()
  };


 const editProduct = async (id) => {

  setEditproductId(id)
   let result = await getProductByID(id)
  setEdit(true)
  handleShow()
  //setCategInit({value: result?.data?.category?._id ,label:result?.data?.category?.name})
  //handleCategoryChange({value: result?.data?.category?._id ,label:result?.data?.category?.name})
  setValue('category', {value: result?.data?.category?._id ,label:result?.data?.category?.name} , { shouldValidate: true });
  //setBrandInit({value: result?.data?.brand?._id,label:result?.data?.brand?.name })
  setValue('brand', {value: result?.data?.brand?._id,label:result?.data?.brand?.name } , { shouldValidate: true });
  //setTypeInit({value: result?.data?.type?._id, label:result?.data?.type?.name })
  setValue('type', {value: result?.data?.type?._id, label:result?.data?.type?.name } , { shouldValidate: true });
  //result?.data?.assembleCharge ? setAssembleCharge(result?.data?.assembleCharge) : ''
  if (result?.data?.assembleCharge !== null && result?.data?.assembleCharge !== undefined && result?.data?.assembleCharge !== 'null' && result?.data?.assembleCharge !== 'undefined'  && result?.data?.assembleCharge !== ''   ){
    setAssembleCharge(result?.data?.assembleCharge)
  }
  setAverageRating(result?.data?.averageRating)
  setDescription(result?.data?.description)
  result?.data?.isActive ? setIsChecked(true) : setIsChecked(false)
  setValue('mrpprice', result?.data?.mrpprice)
  setValue('ourprice', result?.data?.ourprice)
  setValue('quantity', result?.data?.quantity)
  setValue('transptype', result?.data?.transportationtype)
  setValue('name', result?.data?.name)
  setFormImage(`${Baseurl}/view/imageupload/${result?.data?.img}`)

  if(result?.data?.subimg1 !== 'undefined' ){
    setFormsubimage1(`${Baseurl}/view/imageupload/${result?.data?.subimg1}`) 
  }
  if(result?.data?.subimg2 !== 'undefined' ){
    setFormsubimage2(`${Baseurl}/view/imageupload/${result?.data?.subimg2}`) 
  }
  if(result?.data?.subimg3 !== 'undefined' ){
    setFormsubimage3(`${Baseurl}/view/imageupload/${result?.data?.subimg3}`) 
  }
  setDeleteid(id)
  setHeadingPairs(result?.data?.specs) 
  };
  
  const afterProductDelete = async () => {
    let product = await getProduct()
    setProduct(product.data.data)
    handlePageChange(totalPages > 1 ? 1 : 0)
  }

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  const handleFirstPage = () => {
    setCurrentPage(1);
    window.scrollTo(0, 0);
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
    window.scrollTo(0, 0);
  };

  
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxPagesToShow = 5; // Show 5 page numbers at a time
    
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = startPage + maxPagesToShow - 1;
    
    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }
    
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    
    return pageNumbers;
  };

useEffect(() =>  {
    ( async () => {
     await init()
    }
)() 
return () =>  init()
},[])      

useEffect(() =>  {
  ( async () => {
    let product = await getProduct(searchterm,currentPage)
    setProduct(product.data.data)
    setTotalPages(product.data.totalPages);
  }
)() 
},[searchterm, currentPage])      

  return (
    <div>
               <div className="right-content">
                            <div class="page-head d-flex justify-content-between align-items-center flex-wrap">
                             <h1>MANAGE PRODUCTS</h1> 
                             <div>
                              <button className="tb-add-btn" onClick={handleShow}>Add Products+</button>
                              <div class="search-table">
                                <input type="text" value={searchterm} className="form-control text-white w-auto table-search" placeholder="Search" onChange={(e) => setSearchterm(e.target.value)} />
                              </div>
                             </div>
                           </div>
                           
                           <div class="container-fluid p-0">
                               <div class="card">
                                 <div class="table-responsive cmn-table dragscroll">
                                <div className='text-white'>{isModalOpen ? <Deletemodal isModalOpen={isModalOpen} deleteid={deleteid} closeModal={handleDeleteModal} afterProductDelete={afterProductDelete} proddelete={'proddelete'} /> : <></>}</div>
                                 <table class="w-100">
                                     <thead className='text-white'>
                                      <tr>  
                                      <th>No.</th>   
                                      <th>Name</th>   
                                      <th>Description</th>   
                                      <th>Mrp Price.</th>   
                                      <th>Our Price</th>    
                                      <th>Quantity</th>
                                      <th>Active</th>
                                      <th>Other Images</th>
                                      <th>Details</th>
                                      <th>Edit</th>
                                      <th>Delete</th>
                                      <th width="200"></th>     
                                     </tr>
                                     </thead>
                                     <tbody>
                                     {
                                        product.map((item,index) => {
                                           const serialNumber = (currentPage  - 1) * 10 + index + 1;
                                            return (
                                                <tr key={item._id} className='text-white'>
                                                <td>{serialNumber}</td>
                                                <td><img src={`${Baseurl}/view/imageupload/${item.img}`} class="user-img me-2" />{item?.name}</td>
                                                <td><QuillTextDisplay text={item?.description?.slice(0,40)} /></td>
                                                <td>{item?.mrpprice}</td>
                                                <td>{item?.ourprice}</td>
                                                <td>{item?.quantity}</td>
                                                <td>{item?.isActive ? "Active" : "InActive"}</td>

                                                <td> 
                                                     <div className='me-1'> <img style={{width:'50px',height:'50px'}}  src={`${Baseurl}/view/imageupload/${item?.img}`} /> </div> 
                                                </td>
                                                <td><button class="act-btns"  onClick={() => {navigate(`/home/prod/${item._id}`)}}  ><i class="far fa-edit"></i> Detail</button></td>
                                                <td class="">
                                                <button class="act-btns"  onClick={() => {editProduct(item._id)}}  ><i class="far fa-edit"></i> Edit</button>  </td>
                                                <td><button onClick={() => {handleProductDelete(item._id)}} class="act-btns"><i class="far fa-ban"></i> Delete</button> </td>
                                               
                                                </tr>
                                            )
                                        } )
                                     }
                                  
                                         
                                     </tbody>
                                    </table>

                                    </div>
                                {/* <nav aria-label="Page navigation">
                                      <ul class="pagination justify-content-end mt-3">
                                        <li class="page-item">
                                          <a class="page-link" href="#" aria-label="Previous">
                                            <span aria-hidden="true"><i class="fas fa-caret-left"></i></span>
                                          </a>
                                        </li>
                                        <li class="page-item active"><a class="page-link" href="#">1</a></li>
                                        <li class="page-item"><a class="page-link" href="#">2</a></li>
                                        <li class="page-item"><a class="page-link" href="#">3</a></li>
                                        <li class="page-item">
                                          <a class="page-link" href="#" aria-label="Next">
                                            <span aria-hidden="true"><i class="fas fa-caret-right"></i></span>
                                          </a>
                                        </li>
                                      </ul>
                                    </nav> */}
                                    <div className="container mt-4">
          {totalPages > 0 && (
            <nav aria-label="Page navigation">
              <ul className="pagination justify-content-center">
                {/* First Page Button */}
                <li className={`page-item  ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button 
                    className="page-link d-flex justify-content-center" 
                    onClick={handleFirstPage}
                    disabled={currentPage === 1}
                  >
                    First
                  </button>
                </li>
                
                {/* Previous Button */}
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button 
                    className="page-link d-flex justify-content-center " 
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    &laquo;
                  </button>
                </li>
                
                {/* Page Numbers */}
                {getPageNumbers().map(number => (
                  <li 
                    key={number} 
                    className={`page-item ${currentPage === number ? 'active' : ''}`}
                  >
                    <button
                      className="page-link d-flex justify-content-center "
                      onClick={() => handlePageChange(number)}
                    >
                      {number}
                    </button>
                  </li>
                ))}
                
                {/* Next Button */}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <button 
                    className="page-link d-flex justify-content-center " 
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    &raquo;
                  </button>
                </li>
                
                {/* Last Page Button */}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <button 
                    className="page-link d-flex justify-content-center " 
                    onClick={handleLastPage}
                    disabled={currentPage === totalPages}
                  >
                    Last
                  </button>
                </li>
              </ul>
            </nav>
          )}
    
    </div>
                               </div> 
                           </div>  
                        </div>

{/* modal start from here  */}
        

{ show ? <Modal className='modal dark-modal profile-edit fade' show={show} onHide={handleClose}>
        <Modal.Header closeButton className='border-0'>
          <Modal.Title className='text-white'>{edit ? 'Edit Product' : 'Add Products' }</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="cm-form">
            <label>NAME</label>
            <input type="text"  className="form-control" placeholder="Frank Johns" onChange={(e)=>{setName(e.target.value); setValue('name', e.target.value)}}
           {...register('name', { required: 'Name is required' })} />
           {errors.name && <p style={{ color: 'red' }}>{errors.name.message}</p>}
            <label className='mt-1'>CATEGORY</label>
            <Controller
  name="category"
  control={control} // add control to your useForm() destructuring
  rules={{ required: 'Category is required' }}
  render={({ field }) => (
    <Select 
      options={categ}
      //defaultValue={categInit}
      onChange={(selectedOption) => {
        field.onChange(selectedOption);
        handleCategoryChange(selectedOption);
      }}
      value={field.value}
    />
  )}
/>
            {errors.category && <p style={{ color: 'red' }}>{errors.category.message}</p>}
           
            <label className="mt-4">DESCRIPTION</label>
            <Editor className="mb-3 text-white" value={description} onTextChange={(e) => setDescription(e.htmlValue)} style={{ height: '220px' }}
              />
           <div className='d-flex '>
           <span><label className='mt-4'>PRODUCT ACTIVE</label> </span>
    <span className='ms-5 mt-3'>
           <ButtonGroup>
      <Button
        variant={isChecked ? 'primary' : 'outline-primary'}
        onClick={handleYes}
      >
        Yes
      </Button>
      <Button
        variant={!isChecked ? 'primary' : 'outline-primary'}
        onClick={handleNo}
      >
        No
      </Button>
    </ButtonGroup> </span>

           </div> 
            <label className='mt-3'>MRP PRICE</label>
            <input type="number" value={mrpprice} className="form-control" onChange={(e)=>{setMrpprice(e.target.value)}} 
              {...register('mrpprice', { required: 'MrpPrice is required' })} />
           {errors.mrpprice && <p style={{ color: 'red' }}>{errors.mrpprice.message}</p>} 

            <label>Assemble Charge</label>
            <input type="number" value={assemblecharge} className="form-control" onChange={(e)=>{setAssembleCharge(e.target.value)}} /> 
            <label>OUR PRICE</label>
            <input type="number" value={ourprice} className="form-control" onChange={(e)=>{setOurprice(e.target.value)}} 
              {...register('ourprice', { required: 'OurPrice is required' })} />
           {errors.ourprice && <p style={{ color: 'red' }}>{errors.ourprice.message}</p>}  
            <label>TYPE</label> handleTypeChange
            {/* <Select options={typedata} defaultValue={typeInit} onChange={handleTypeChange}  /> */}
            <Controller
  name="type"
  control={control} // add control to your useForm() destructuring
  rules={{ required: 'Type is required' }}
  render={({ field }) => (
    <Select 
      options={typedata}
      //defaultValue={categInit}
      onChange={(selectedOption) => {
        field.onChange(selectedOption);
        handleTypeChange(selectedOption);
      }}
      value={field.value}
    />
  )}
/>
            {errors.type && <p style={{ color: 'red' }}>{errors.type.message}</p>}
            <label className='mt-3'>Brand</label>
            {/* <Select options={brand} defaultValue={brandInit} onChange={handleBrandChange}  /> */}
            <Controller
  name="brand"
  control={control} // add control to your useForm() destructuring
  rules={{ required: 'Brand is required' }}
  render={({ field }) => (
    <Select 
      options={brand}
      //defaultValue={categInit}
      onChange={(selectedOption) => {
        field.onChange(selectedOption);
        handleBrandChange(selectedOption);
      }}
      value={field.value}
    />
  )}
/>
            {errors.brand && <p style={{ color: 'red' }}>{errors.brand.message}</p>}
            <label className='mt-3'>QUANTITY</label> 
            <input type="number" value={quantity}  className="form-control" placeholder="Quantity" onChange={(e)=>{setQuantity(e.target.value)}} 
             {...register('quantity', { required: 'Quantity is required' })} />
           {errors.quantity && <p style={{ color: 'red' }}>{errors.quantity.message}</p>}  
            <label>Transportation Type</label>
            <input type="text" value={transptype} className="form-control" placeholder="" onChange={(e)=>{setTransptype(e.target.value)}} 
                {...register('transptype', { required: 'Transportation is required' })} />
           {errors.transptype && <p style={{ color: 'red' }}>{errors.transptype.message}</p>} 
          
            {/* <label>Features</label> */}
            {/* <div>
            <span className='d-flex'>
            <input
          type="Field" className="form-control"
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyPress}
          placeholder="Enter text..."
        />
        <button className='h-50 p-2 mt-1' onClick={handleAddClick}>+</button>
            </span>
       
      </div> */}
      {/* <div className='text-white border mt-1'>
        {items.map((item, index) => (
          <div className='pt-1' key={index}>{item}</div>
        ))}
      </div> */}

           
       <label>MainImage</label>
       <ImageCropper ref={image} aspectRatio="1:1"
          circleMode={false}
          lockAspectRatio={true}   />

           {formimage && edit ? <div style={{ position: 'relative', display: 'inline-block' }}>
              <span className='fs-6 text-white'>{edit ? 'Selected main Image' : 'Selected Image' }</span>
              <div>
              <img
            src={formimage}
            alt="Uploaded"
            style={{ maxWidth: '100px', maxHeight: '200px' }}
          /> </div> </div> : <></> }
            {/* <input type="file"  ref={image} className="form-control" placeholder="" accept="image/jpeg, image/png, image/jpg" onChange={handleImageChange}/>
            {formimage ?<div style={{ position: 'relative', display: 'inline-block' }}>
              <span className='fs-6 text-white'>Selected Image</span>
              <div>
              <img
            src={formimage}
            alt="Uploaded"
            style={{ maxWidth: '100px', maxHeight: '200px' }}
          /> */}
          {/* <button
            onClick={() => handleRemoveImage(1)}
            style={{
              position: 'absolute',
              top: '23px',
              right: '5px',
              border: 'none',
              borderRadius: '50%',
              padding: '2px',
              cursor: 'pointer',
            }}
          >
            X
          </button>
              </div>
            </div> : <></>} */}

            <label>SubImage1</label>
            <ImageCropper ref={subimage1} aspectRatio="1:1"
          circleMode={false}
          lockAspectRatio={true}/>
          {/* {formsubimage1 && edit ?<div style={{ position: 'relative', display: 'inline-block' }}>
              <span className='fs-6 text-white'>{edit ? 'Selected SubImage1' : 'Selected Image' }</span>
              <div>
              <img
            src={formsubimage1}
            alt="Uploaded"
            style={{ maxWidth: '100px', maxHeight: '200px' }}
          /> </div> </div> : <></>} */}
            {/* <input type="file"  ref={subimage1} className="form-control" placeholder="" accept="image/jpeg, image/png, image/jpg" onChange={handleImageChange1}/> */}
            {formsubimage1 && edit  ? <div style={{ position: 'relative', display: 'inline-block' }}>
              <span className='fs-6 text-white'>Selected Image</span>
              <div>
              <img
            src={formsubimage1}
            alt="Uploaded"
            style={{ maxWidth: '100px', maxHeight: '200px' }}
          />
          <button
            onClick={() => handleRemoveImage(2)}
            style={{
              position: 'absolute',
              top: '23px',
              right: '5px',
              border: 'none',
              borderRadius: '50%',
              padding: '2px',
              cursor: 'pointer',
            }}
          >
            X
          </button>
              </div>
            </div> : <></>}
{/* //////////////////////////////////////// */}
         <div><label>SubImage2</label></div>
         <ImageCropper ref={subimage2} aspectRatio="1:1"
          circleMode={false}
          lockAspectRatio={true} />
           {/* {formsubimage2 && edit ?<div style={{ position: 'relative', display: 'inline-block' }}>
              <span className='fs-6 text-white'>{edit ? 'Selected SubImage2' : 'Selected Image' }</span>
              <div>
              <img
            src={formsubimage2}
            alt="Uploaded"
            style={{ maxWidth: '100px', maxHeight: '200px' }}
          /> </div> </div> : <></>} */}
            {/* <input type="file"  ref={subimage2} className="form-control" placeholder="" accept="image/jpeg, image/png, image/jpg" onChange={handleImageChange2}/> */}
            {formsubimage2 && edit ?<div style={{ position: 'relative', display: 'inline-block' }}>
              <span className='fs-6 text-white'>Selected Image</span>
              <div>
              <img
            src={formsubimage2}
            alt="Uploaded"
            style={{ maxWidth: '100px', maxHeight: '200px' }}
          />
          <button
            onClick={() => handleRemoveImage(3)}
            style={{
              position: 'absolute',
              top: '23px',
              right: '5px',
              border: 'none',
              borderRadius: '50%',
              padding: '2px',
              cursor: 'pointer',
            }}
          >
            X
          </button>
              </div>
            </div> : <></>}

            <div><label>SubImage3</label></div>
            <ImageCropper ref={subimage3} aspectRatio="1:1"
          circleMode={false}
          lockAspectRatio={true} />
           {/* {formsubimage3 && edit ?<div style={{ position: 'relative', display: 'inline-block' }}>
              <span className='fs-6 text-white'>{edit ? 'Selected SubImage3' : 'Selected Image' }</span>
              <div>
              <img
            src={formsubimage3}
            alt="Uploaded"
            style={{ maxWidth: '100px', maxHeight: '200px' }}
          /> </div> </div> : <></>} */}
            {/* <input type="file"  ref={subimage3} className="form-control" placeholder="" accept="image/jpeg, image/png, image/jpg" onChange={handleImageChange3}/> */}
            {formsubimage3 && edit ? <div style={{ position: 'relative', display: 'inline-block' }}>
              <span className='fs-6 text-white'>Selected Image</span>
              <div>
              <img
            src={formsubimage3}
            alt="Uploaded"
            style={{ maxWidth: '100px', maxHeight: '200px' }}
          />
          <button
            onClick={() => handleRemoveImage(4)}
            style={{
              position: 'absolute',
              top: '23px',
              right: '5px',
              border: 'none',
              borderRadius: '50%',
              padding: '2px',
              cursor: 'pointer',
            }}
          >
            X
          </button>
              </div>
            </div> : <></>}
{/* {
  edit ? <div>
  {specInit?.map((item,index) =>
    (
      <div className='text-white' key={index}>
        <span>{item?.heading}</span>
      </div>
    )
  )}
   </div> : <></>
} */}

        <div> <label className="text-xl font-bold mb-4">Dynamic Heading Inputs</label>  
      
      {headingPairs.map((pair, index) => (
        <div key={index} className="mb-4 d-flex gap-2 justify-content-between align-items-center">
         
            <input
              type="text"
              placeholder="Heading"
              value={pair.heading}
              onChange={(e) => updatePair(index, 'heading', e.target.value)}
              className="w-full p-2 border border-gray-300 text-dark rounded"
            />
         
            <input
              type="text"
              placeholder="Value"
              value={pair.value}
              onChange={(e) => updatePair(index, 'value', e.target.value)}
              className="w-full p-2 border text-dark  border-gray-300 rounded"
            />

          <button 
            onClick={() => deletePair(index)}
            className="p-2 bg-red-500 text-dark rounded hover:bg-red-600"
            aria-label="Delete row"
          >
            ✕
          </button>
        </div>
      ))}
      
      <div className="flex gap-2 mt-4">
        <button 
          onClick={addHeadingPair}
          className="p-2 bg-blue-500 text-dark rounded hover:bg-blue-600"
        >
          + Add More
        </button>
        
        <button 
          onClick={saveData}
          className="p-2 bg-green-500 text-dark rounded hover:bg-green-600"
        >
          Save
        </button>
      </div> </div>  
      
      {savedData.length > 0 && (
        <div className="mt-6">
          <h3 className="text-white  mb-2">Data Saved</h3>
          {/* <pre className="bg-gray-100 text-white  p-4 rounded overflow-x-auto">
            {JSON.stringify(savedData, null, 2)}
          </pre> */}
        </div>
      )}
     
            {/* <div>
            <label>SubImages</label>
            <input type="file" ref={subImages}  className="form-control" accept="image/jpeg, image/png, image/jpg" multiple onChange={handleSubimages} />
            </div>
            */}

            {/* {formsubimages ?   <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {formsubimages?.map((image, index) => (
          <div key={index} style={{ position: 'relative', margin: '5px' }}>
            <img
              src={image}
              alt={`Uploaded ${index}`}
              style={{ maxWidth: '70px', maxHeight: '70px' }}
            />
            <button
              onClick={() => handleRemoveImages(index)}
              style={{
                position: 'absolute',
                top: '',
                right: '5px',
                background: 'rgba(255, 255, 255, 0.7)',
                border: 'none',
                borderRadius: '50%',
                padding: '5px',
                cursor: 'pointer',
              }}
            >
              X
            </button>
          </div>
        ))}
      </div> :<></>} */}

            {/* {formsubimages ?<div style={{ position: 'relative', display: 'inline-block' }}>
              <span className='fs-6 text-white'>Selected Image</span>
              <div>
              <img
            src={formsubimages}
            alt="Uploaded"
            style={{ maxWidth: '100px', maxHeight: '200px' }}
          />
          <button
            onClick={handleRemoveImages}
            style={{
              position: 'absolute',
              top: '23px',
              right: '5px',
              border: 'none',
              borderRadius: '50%',
              padding: '2px',
              cursor: 'pointer',
            }}
          >
            X
          </button>
              </div>
            </div> : <></>} */}

          </div>
        </Modal.Body>
        <Modal.Footer className='d-flex justify-content-between border-0'>
          <button className='cancel' onClick={handleClose}>
            Cancel
          </button>
          <button type='submit' className='save' onClick={handleSubmit(handleSubmits)}>
            Save
          </button>
        </Modal.Footer>
      </Modal> : <></>}
    </div>
  )
}

export default Products
